import { BaseWindowView } from '../../base/BaseWindowView';
/**
 * フッタービュー情報
 */
export class FooterComponentView extends BaseWindowView {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('cpagetop', '先頭へ移動', null);
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		this.addAction('pagetop',				this.onPageTop,	false, true);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		this.refreshView();
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 先頭へ移動
	 */
	public onPageTop(event: any): void {
		event.preventDefault();
		this.scrollToTop();
	}
	// --------------------------------------------------------------------------
}